import { render, staticRenderFns } from "./MailTemplates.create.vue?vue&type=template&id=43f6c2e2&"
import script from "./MailTemplates.create.vue?vue&type=script&lang=js&"
export * from "./MailTemplates.create.vue?vue&type=script&lang=js&"
import style0 from "./MailTemplates.create.vue?vue&type=style&index=0&id=43f6c2e2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports